// extracted by mini-css-extract-plugin
export default {"underline":"MenuModal_underline__lhcqt"};